import React, { forwardRef } from 'react';

import VrmChecker, { VrmCheckerBaseProps } from '../VrmChecker/VrmChecker';
import VrmUlezChecker from '../VrmUlezChecker/VrmUlezChecker';

export const VrmCheckerFooter = forwardRef<React.ComponentRef<typeof VrmChecker>, Partial<VrmCheckerBaseProps> &
{ useUlezVrmChecker?: boolean } >(
  ({ useUlezVrmChecker = false, ...props }, ref) => (
    useUlezVrmChecker
      ? <VrmUlezChecker hideErrors inFooter />
      : <VrmChecker ref={ref} {...props} />
  ),
);
